import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ref, onMounted } from 'vue';
import { useAcknowledgementStore } from '../../store/';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Snackbar',
    props: {
        value: { type: Object, required: true },
        bottomClass: { type: String, required: true },
    },
    setup: function (__props) {
        var props = __props;
        var acknowledgementStore = useAcknowledgementStore();
        var isHidden = ref(false);
        onMounted(function () {
            var timeout = props.value.timeout;
            if (props.value.to) {
                var url = props.value.to;
                acknowledgementStore.replaceAcknowledgement(props.value.id);
                window.location.href = url;
            }
            else {
                setTimeout(function () {
                    isHidden.value = true;
                    acknowledgementStore.closeAcknowledgement(props.value.id);
                }, timeout);
            }
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["fixed z-[100] left-0 flex justify-center w-full", __props.bottomClass])
            }, [
                _createElementVNode("p", {
                    class: _normalizeClass(["p-4 w-w32 tablet:w-contents text-white text-14px bg-grey-60 rounded shadow-md", { hidden: isHidden.value }])
                }, _toDisplayString(__props.value.message), 3)
            ], 2));
        };
    }
});
